import store from '@/store'
export default [
  {
    path: '/disciplinary-activities',
    name: 'disciplinary-activity',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-activity/index.vue')
  },
  {
    path: '/disciplinary-activities/:id',
    name: 'disciplinary-activity-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-activity/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await store.dispatch(
        'disciplinaryActivity/find',
        to.params.id
      )
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
